export type WidgetControllerMethods = {
  openLauncher: () => void;
};

type MethodName = keyof WidgetControllerMethods;

const handlers: Partial<WidgetControllerMethods> = {};
const pendingCalls = new Set<MethodName>();

export const registerWidgetControllerMethod = <M extends MethodName>(
  method: M,
  handler: WidgetControllerMethods[M]
) => {
  handlers[method] = handler;
  if (pendingCalls.has(method)) {
    pendingCalls.delete(method);
    handler();
  }
};

export const unregisterWidgetControllerMethod = (method: MethodName) => {
  delete handlers[method];
};

export const callWidgetController = (method: MethodName) => {
  const handler = handlers[method];
  if (handler) {
    handler();
  } else {
    pendingCalls.add(method);
  }
};
